<template>
  <v-dialog v-model="showBulkModificationModal" persistent>
    <v-card>
      <v-toolbar dark color="primary" fixed class="sticky-top">
        <v-toolbar-title>
          <v-icon>mdi-filter</v-icon>
          {{
            $i18n.t("Bulk Modification") +
            " (" +
            $i18n.t("Please select accordingly which need to be updated") +
            ")"
          }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon dark @click="closeDialog">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>

      <v-card-text class="py-0">
        <v-col cols="12" sm="12" md="12" lg="12">
          <v-row>
            <v-col cols="12" sm="12" md="4" lg="3">
              <v-select
                :label="$i18n.t('New Zone')"
                :items="zoneList"
                v-model="bulkUpdate.zone"
                item-text="name"
                item-value="_id"
              ></v-select>
            </v-col>
          </v-row>
        </v-col>
      </v-card-text>

      <v-card-actions class="sticky-bottom">
        <v-spacer></v-spacer>
        <v-btn @click="finalUpdate" color="blue" :loading="loading">
          <v-icon small>mdi-save</v-icon>
          {{ $i18n.t("Update") }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>


<script>
import { Vue, Component, Watch } from "vue-property-decorator";
import { doGet, doPost } from "@/store/common/module/apis";
import { VueEditor } from "vue2-editor";
import Themeable from "vuetify/lib/mixins/themeable";
import common from "@/store/common/module/common";

@Component({
  name: "BulkModificationTariff",
  props: {
    payload: {
      default: null,
    },
    showDialog: {
      default: null,
    },
    refresh: {
      default: null,
    },
  },
  components: {
    VueEditor,
  },
})
export default class BulkModificationDriver extends (Vue, Themeable) {
  showBulkModificationModal = null;
  bulkUpdate = {};
  loading = false;
  zoneList = [];

  async mounted() {
    this.zoneList = await doGet("/api/corp/zones/get");
    if (!this.zoneList) this.zoneList = [];
    this.zoneList.unshift({ name: "Unassign", _id: "unassign" });
  }

  closeDialog() {
    this.showBulkModificationModal = false;
    this.$emit("closeDialog", false);
  }

  @Watch("showDialog")
  onShowDialogChange(val) {
    this.showBulkModificationModal = val;
  }

  @Watch("showBulkModificationModal")
  async onDialogChange() {
    // console.log("Dialog open");
  }

  async finalUpdate() {
    this.loading = true;
    const data = {};
    data.zone = this.bulkUpdate.zone;
    data.driver_ids = this.payload.driver_ids;
    if (!data.zone) {
      common.setError("Please Select zone !");
      this.loading = false;
      return;
    }

    common.setLoading(true);
    try {
      await doPost("/api/driver/bulk/modify", data);
      common.showMessage("Updated Successfully");
      common.setLoading(false);
      this.loading = false;
      await this.refresh(1);
      this.closeDialog();
    } catch (e) {
      common.setError(e.message);
      common.setLoading(false);
      this.loading = false;
    }
  }
}
</script>
